import { HideOccludingObjectsComponentIds } from './types';
export class FadeAnimationComponent {
    constructor(playAnimation) {
        this.playAnimation = playAnimation;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.typeId = HideOccludingObjectsComponentIds.FADE_ANIMATION_COMPONENT_ID;
    }
    eq(other) {
        return Boolean(other);
    }
}
//# sourceMappingURL=FadeAnimationComponent.js.map